import React from "react";
import PropTypes from "prop-types";

import ReactTable from "react-table";

import Loading from "../../common/Loading";

import { CUSTOMER_ANNUAL_REVENUE_ANALYSIS_COLUMNS } from "./columns";

const CustomerAnnualRevenueAnalysisList = ({
  data,
  loading,
  onRowClick = () => {},
  years
}) => {
  if (loading)
    return (
      <div className="loading">
        <Loading />
      </div>
    );

  return data && data.length ? (
    <div className="content-wrapper">
      <ReactTable
        className="-highlight"
        data={data}
        columns={CUSTOMER_ANNUAL_REVENUE_ANALYSIS_COLUMNS(years, false)}
        pageSize={data.length}
        showPagination={false}
        getTrProps={(state, rowInfo) => ({
          onClick: () => onRowClick(rowInfo)
        })}
      />
    </div>
  ) : (
    <div className="loading">
      <h4 style={{ opacity: 0.15 }}>No Data</h4>
    </div>
  );
};
CustomerAnnualRevenueAnalysisList.propTypes = {
  data: PropTypes.array,
  loading: PropTypes.bool,
  onRowClick: PropTypes.func,
  years: PropTypes.array
};

export default CustomerAnnualRevenueAnalysisList;
